<template>
  <div style="height: 70vh; width: 100%; mx-2" class="position-relative">
    <!-- Filter panel -->
<!-- Toggle Button -->
    <button
      class="btn btn-sm btn-dark position-absolute m-2 toggleBtn"
      style=""
      @click="toggleFilters"
    >
      <i class="bi bi-funnel-fill" v-if="showFilters"></i>
      <i class="bi bi-funnel"  v-if="!showFilters" ></i>

    </button>

    <!-- Filter Drawer -->
    <transition name="slide-fade">
      <div
        v-if="showFilters"
        id="searchbar"
        class="bg-white p-2 rounded shadow position-absolute w-100"
        style=""
      >
        <div class="row g-2 align-items-center">
          <!-- Region Select -->
          <div class="col-12 col-md-2">
            <select class="form-select" v-model="filters.region" @change="onRegionChange">
              <option value="">All Regions</option>
              <option v-for="region in regions" :key="region" :value="region">
                {{ region }}
              </option>
            </select>
          </div>

          <!-- District Select -->
          <div class="col-12 col-md-2">
            <select
              class="form-select"
              v-model="filters.district"
              @change="onDistrictChange"
              :disabled="!filters.region"
            >
              <option value="">All Districts</option>
              <option v-for="district in availableDistricts" :key="district" :value="district">
                {{ district }}
              </option>
            </select>
          </div>

          <!-- Community Select -->
          <div class="col-12 col-md-2">
            <select class="form-select" v-model="filters.community" :disabled="!filters.district">
              <option value="">All Communities</option>
              <option v-for="community in availableCommunities" :key="community" :value="community">
                {{ community }}
              </option>
            </select>
          </div>

          <!-- Total Count -->
          <div class="col-12 col-md-2">
            <input
              type="number"
              class="form-control"
              v-model="filters.minCount"
              placeholder="#Min count"
            />
          </div>

          <!-- Trap Reports -->
          <div class="col-12 col-md-2">
            <input
              type="number"
              class="form-control"
              v-model="filters.minReports"
              placeholder="#Min reports"
            />
          </div>

          <!-- Button -->
          <div class="col-12 col-md-2">
            <button class="btn btn-sm btn-dark w-100" @click="applyFilters">
              Apply
            </button>
          </div>
        </div>
      </div>
    </transition>


    <l-map ref="map" v-model:zoom="zoom" :center="center">
      <l-tile-layer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" layer-type="base"
        :attribution="attribution" name="OpenStreetMap"></l-tile-layer>
      <span v-if="traps.length > 0">
        <l-circle-marker v-for="(trap, i) in traps" :key="i" :lat-lng="[trap.latitude, trap.longitude]"
          :color="getColor(trap.total_count)" :radius="10">
          <l-popup ref="popup">
            <h6 class="fw-bold my-0">{{ trap.name }} </h6>
            <p class="my-0 location_crump">{{ trap.region }} > {{ trap.district }} > {{ trap.community }}</p>
            <p>{{ trap.total_count }} occurances countedfrom {{ trap.trap_reports.length }} report(s)</p>
            <button class="btn-sm text-light btn-dark btn d-block w-100" @click="$emit('more_info', trap)">Show Report
              logs</button>
          </l-popup>
        </l-circle-marker>
      </span>
    </l-map>
  </div>
</template>

<script>
import "leaflet/dist/leaflet.css";
import { ColorPicker } from "vue3-colorpicker";
import "vue3-colorpicker/style.css";
import {
  LMap,
  LTileLayer,
  LPolygon,
  LPopup,
  LMarker,
  LCircleMarker
} from "@vue-leaflet/vue-leaflet";
import axios from "axios";

export default {
  components: {
    LMap,
    LTileLayer,
    LPolygon,
    LPopup,
    LMarker,
    LCircleMarker,
    ColorPicker
  },
  emits: ['more_info', 'filters'],
  props: {
    traps: Array
  },
  data() {
    return {
            showFilters: false, 
      attribution: '&copy; <a href="https://www.esri.com/en-us/home">Esri</a>',
      msg: '',
      jwt: {},
      centerCoordinates: "",
      riskLocation: {},
      index: 0,
      districtData: [],
      searchInput: "",
      zoom: 10,
      center: [9.525703625988754, -1.0030534558847726],
      geojson: null,
      geoStyler: (feature) => ({
        opacity: feature.properties.code / 100000,
        radius: 8,
        fillColor: "#198754",
        color: "#fff",
        weight: 1,
        fillOpacity: 0.5,
      }),
      filters: {
        region: "",
        district: "",
        community: "",
        minCount: null,
        minReports: null,
      },
      regionDistrictCommunityMap: {}, // backend mapping
    
    };
  },
  created() {
     this.fetchRegionsDistrictsCommunities();
  },
  methods: {
    onPopupOpen(data) { },
    closePopup() { },

    toggleFilters() {
      this.showFilters = !this.showFilters;
    },

    changeCenter(centerPoint) {
      this.center = centerPoint.split(", ").map(Number);
      this.zoom = 15;
    },

    getColor(count) {
      if (count < 10) return "#198754"; // green
      if (count < 20) return "#ffc107"; // yellow
      return "#dc3545"; // red
    },

    async fetchRegionsDistrictsCommunities() {
      try {
        const res = await axios.get("https://aghub.miphost.com/api/broadcast/trap-regions-districts");
        this.regionDistrictCommunityMap = res.data;
      } catch (err) {
        console.error("Error fetching regions/districts/communities:", err);
      }
    },
    onRegionChange() {
      this.filters.district = "";
      this.filters.community = "";
    },
    onDistrictChange() {
      this.filters.community = "";
    },
    applyFilters() {
      this.$emit("filters", this.filters);
    },
    getCookie(cname) {
      let name = cname + "=";
      let ca = document.cookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
  },
  computed: {
    regions() {
    return Object.keys(this.regionDistrictCommunityMap || {});
  },
 availableDistricts() {
  if (!this.filters.region) return [];
  return Object.keys(this.regionDistrictCommunityMap[this.filters.region] || {});
},

availableCommunities() {
  if (!this.filters.region || !this.filters.district) return [];
  return this.regionDistrictCommunityMap[this.filters.region][this.filters.district] || [];
},
  },
  watch: {
    polygonPoints: {
      handler(newPoints) {
        if (newPoints.length && newPoints[0]) {
          this.polygonPoints[this.numPoints - 1] = newPoints[0];
        }
      },
      deep: true,
    },
  },
};
</script>
<style scoped>


.btn-font {
  font-size: 15px;
}

#searchbar {
  max-width: fit-content;
  top: 10px;
  left: 70px;
  right: 0;
  z-index: 1000;
  transform: none;
}

#formBar {
  top: 50%;
  right: 1%;
  transform: translate(0%, -50%);
  z-index: 1000;
}

#addBtn {
  top: 10%;
  right: 0%;
  z-index: 1000;
}

@media (max-width: 575.98px) {
  #searchbar {
    top: 5px;
    left: 0;
    right: 0;
    z-index: 1000;
  }

  #formBar {
    top: 50%;
    right: 2%;
    transform: translate(0%, -50%);
    z-index: 1000;
  }
}

.location_crump {
  font-size: 10px !important;
}

/* Smooth drawer transition */
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}
.slide-fade-enter-from,
.slide-fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
.toggleBtn {
  z-index:1100; 
  top: 0; 
  right: 0
}
</style>
